import { CustomerTree, OneXInteractionObject, ResponsiveTray, ResponsiveTrayProps } from '@vfmfe/foundations';
import { useSelector, useStore } from '../../modules/store';
import { loadTreeData, recontextualizeInteraction } from '../../utils/interaction';
import { useLoading } from '../../providers/Loading/LoadingProvider';

const CustomerTreeForInteraction = ({ interaction }: { interaction: OneXInteractionObject }) => {
    const store = useStore();
    const { startLoading, stopLoading } = useLoading();
    const treeRequestState = useSelector((store) => store.interactions.currentInteraction.treeRequestState);
    const tree = useSelector((store) => store.interactions.currentInteraction.context?.tree);
    const currentNode = {
        id: tree?.currentNodeId || interaction.identifier,
        type: tree?.currentNodeType || interaction.contextType!
    };

    return (
        <CustomerTree
            key={currentNode.id + treeRequestState}
            nodes={interaction?.context?.tree?.nodes || []}
            onNodeDoubleClick={async (node) => {
                // Recontextualize the interaction with the double-clicked node
                const loadingId = startLoading('A mudar de contexto...');
                await recontextualizeInteraction(store, node);
                stopLoading(loadingId);
            }}
            onNodeSingleClick={(node) => {
                loadTreeData(store, node);
            }}
            selectedMainNodeId={interaction.identifier}
            currentNode={currentNode}
            state={treeRequestState}
        />
    );
};

const CustomerTreeResponsiveTray = (props: ResponsiveTrayProps) => {
    const interaction = useSelector((store) => store.interactions.currentInteraction);

    if (!interaction) return null;

    return (
        <ResponsiveTray {...props}>
            <CustomerTreeForInteraction interaction={interaction} />
        </ResponsiveTray>
    );
};

export default CustomerTreeResponsiveTray;
